export const REGIONAL_DATA = [
  {
    id: "RSK",
    region: "Rabat-Salé-Kénitra",
    mmr: 48.2,
    cSection: "31.2%",
    danger: "Low",
    status: "Safe",
    trend: "Decreasing",
    source: "MoH ENPSF 2022",
    description: "High concentration of university hospitals and specialized clinics."
  },
  {
    id: "CS",
    region: "Casablanca-Settat",
    mmr: 45.5,
    cSection: "33.5%",
    danger: "Low",
    status: "Safe",
    trend: "Decreasing",
    source: "MoH ENPSF 2022",
    description: "Best medical infrastructure in the kingdom with high private sector ratio."
  },
  {
    id: "DT",
    region: "Drâa-Tafilalet",
    mmr: 128.4,
    cSection: "10.8%",
    danger: "Critical",
    status: "Critical",
    trend: "Stable",
    source: "MoH Rural Survey",
    description: "Extreme geographic barriers. High risk due to travel distance to clinics."
  },
  {
    id: "BMK",
    region: "Béni Mellal-Khénifra",
    mmr: 112.1,
    cSection: "13.5%",
    danger: "Critical",
    status: "Critical",
    trend: "Increasing",
    source: "MoH 2024 Dashboard",
    description: "Mountainous region. Focus area for DeepEcho deployment (Moula Bouaaza)."
  },
  {
    id: "FM",
    region: "Fès-Meknès",
    mmr: 84.6,
    cSection: "18.2%",
    danger: "High",
    status: "High Risk",
    trend: "Decreasing",
    source: "HCP Regional Report",
    description: "Significant disparity between Fès urban center and rural Taounate."
  },
  {
    id: "MS",
    region: "Marrakech-Safi",
    mmr: 72.3,
    cSection: "20.5%",
    danger: "Moderate",
    status: "Moderate",
    trend: "Decreasing",
    source: "MoH ENPSF 2022",
    description: "Marrakech city is well-served, but Safi and Chichaoua require focus."
  },
  {
    id: "TTH",
    region: "Tanger-Tétouan-Al Hoceïma",
    mmr: 54.8,
    cSection: "25.1%",
    danger: "Low",
    status: "Safe",
    trend: "Decreasing",
    source: "MoH 2024 Dashboard",
    description: "Rapidly improving maternal health indicators in the northern axis."
  },
  {
    id: "OR",
    region: "L'Oriental",
    mmr: 89.1,
    cSection: "17.8%",
    danger: "High",
    status: "High Risk",
    trend: "Decreasing",
    source: "Regional Health Dir.",
    description: "Ongoing upgrades to Oujda CHU are helping lower mortality rates."
  },
  {
    id: "SM",
    region: "Souss-Massa",
    mmr: 66.4,
    cSection: "22.9%",
    danger: "Moderate",
    status: "Moderate",
    trend: "Stable",
    source: "HCP 2023 Statistics",
    description: "Agadir serves as the primary hub for the entire southern region."
  },
  {
    id: "GN",
    region: "Guelmim-Oued Noun",
    mmr: 104.5,
    cSection: "11.5%",
    danger: "Critical",
    status: "Critical",
    trend: "Increasing",
    source: "MoH Rural Survey",
    description: "Critical shortage of specialized gynecologists and midwives."
  },
  {
    id: "LSH",
    region: "Laâyoune-Sakia El Hamra",
    mmr: 92.0,
    cSection: "14.2%",
    danger: "High",
    status: "High Risk",
    trend: "Stable",
    source: "HCP 2023 Statistics",
    description: "High investment in new regional hospital centers (CHR)."
  },
  {
    id: "DOD",
    region: "Dakhla-Oued Ed-Dahab",
    mmr: 82.2,
    cSection: "15.8%",
    danger: "Moderate",
    status: "Moderate",
    trend: "Stable",
    source: "Regional Health Dir.",
    description: "Improving primary care but still dependent on evacuations for complexity."
  }
];

export const CENTERS = [
  { id: 'aghbala',        name: 'Aghbala',        lat: 32.4677, lng: -5.6197 },
  { id: 'ait-tamlil',     name: 'Aït Tamlil',     lat: 31.9500, lng: -6.4200 },
  { id: 'anergui',        name: 'Anergui',        lat: 32.0800, lng: -5.9200 },
  { id: 'boutferda',      name: 'Boutferda',      lat: 32.2000, lng: -6.3000 },
  { id: 'el-ksiba',       name: 'El Ksiba',       lat: 32.5698, lng: -6.0250 },
  { id: 'moula-bouaaza',  name: 'Moulay Bouazza', lat: 33.0225, lng: -5.7297 },
  { id: 'ahansal',        name: 'Zaouiat Ahansal', lat: 32.0483, lng: -6.0917 },
  { id: 'taguelft',       name: 'Taguelft',       lat: 32.1783, lng: -5.9611 },
];

